/**
 * @fileOverview The purpose of this middleware is so that you can dispatch
 * an array of actions and this will convert it to the format needed for a
 * batch reducer. i.e.
 *
 * dispatch([{ type: 'ACTION_1' }, { type: 'ACTION_2' }])
 *
 * would be converted to
 * disaptch({
 *  type: 'BATCH_ACTIONS',
 *  payload: {
 *    actions: [{ type: 'ACTION_1' }, { type: 'ACTION_2' }]
 *  }
 * })
 */

export default ({ dispatch, getState }) => next => async action => {

  if (action instanceof Array){
    var batchAction = {
      type: 'BATCH_ACTIONS',
      payload: {
        actions: action,
      }
    }
    return next(batchAction)
  }
  return next(action)
}


// WEBPACK FOOTER //
// ./src/store/batchActions/middleware.js